import Layout from '@/layout';
var woyingRouter = {
  path: '/woying',
  component: Layout,
  redirect: '/woying/special',
  name: 'Woying',
  meta: {
    title: '审核验券管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'special',
    component: function component() {
      return import('@/views/woying/special/index');
    },
    name: 'SpecialIndex',
    meta: {
      title: '审核开卡',
      icon: ''
    }
  }, {
    path: 'yuyue',
    component: function component() {
      return import('@/views/woying/yuyue/index');
    },
    name: 'YuyueIndex',
    meta: {
      title: '预约数据查询',
      icon: ''
    }
  }, {
    path: 'record',
    component: function component() {
      return import('@/views/woying/record/index');
    },
    name: 'RecordIndex',
    meta: {
      title: '使用记录',
      icon: ''
    }
  }, {
    path: 'verification',
    component: function component() {
      return import('@/views/woying/verification/index');
    },
    name: 'VerificationIndex',
    meta: {
      title: '专用券使用',
      icon: ''
    }
  }]
};
export default woyingRouter;